import React, { useMemo } from 'react';
import {
  KeyMetricChart,
  KeyMetricChartData,
} from 'src/components/organisms/KeyMetricChart';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { useLTDataContext } from '../../../contexts/LTDataContext';

export const LongTermEffect: React.FC = () => {
  const { effects, isError, isLoading } = useLTDataContext();

  const { isEuro } = useKpiUnit();

  const keyMetricData: KeyMetricChartData = useMemo(() => {
    let sum = 0;
    const data = effects.monthly.map((x) => {
      const value = x.longTermMediaEffect;
      sum += value;
      return {
        utcEpoch: x.utcEpoch,
        value,
      };
    });

    return {
      name: 'Long term effect',
      data,
      summaryValue: sum,
      isError,
      isEuro,
      isLoading,
    };
  }, [effects, isError, isLoading, isEuro]);

  return <KeyMetricChart keyMetricData={keyMetricData} minH="250px" />;
};
